import React, { useState, useEffect } from 'react';
import { useHistory, useNavigate } from "react-router-dom";
import axios from 'axios';

const ProjectStatusHOD = () => {
  const [status, setStatus] = useState('1');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  // Fetch projects whenever the status changes
  const navigate = useHistory();
  useEffect(() => {
    
    const fetchProjectsByStatus = async () => {
      setLoading(true);
      setError(null);

      try {
        const accessLevel = sessionStorage.getItem('access_level');
        const userId = sessionStorage.getItem('userId');

        if (accessLevel == '5' && accessLevel == '6' && accessLevel == '3' && accessLevel == '2' && accessLevel == '1') {
          setError('You do not have rights to view projects');
          setLoading(false);
          return;
        }
        

        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/statushod`, {
          params: {
            status, // Selected status from the dropdown
            userId, // User ID from session storage
            accessLevel, // Access level from session storage
          },
        });

        setProjects(response.data);
      } catch (err) {
        setError('Failed to fetch projects.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectsByStatus();
  }, [status]); // Triggered when `status` changes

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "bg-warning text-dark"; // Unapproved (orange mixed with yellow)
      case 1:
        return "bg-success text-white"; // Approved (green)
      case 2:
        return "bg-danger text-white"; // Archived (red)
      default:
        return ""; // No color if status is empty or undefined
    }
  };

  return (
    <div className="container mt-4">
      {/* Error and Loading Messages */}
      {error && <div className="alert alert-danger text-center">{error}</div>}
      {loading && <div className="alert alert-info text-center">Loading projects...</div>}

      {/* Status Dropdown */}
      <div className="d-flex justify-content-center mb-4">
        <div className="form-group w-50">
          <label htmlFor="statusSelect" className="form-label">Select Project Status:</label>
          <select
            id="statusSelect"
            className="form-select"
            value={status}
            onChange={handleStatusChange}
          >
           
            {/*<option value="0">UnApproved</option>*/}
            <option value="1">Approved Level 1</option>
            {/*<option value="2">Archived</option>*/}
            <option value="3">Approved Level 2</option>
            <option value="0">UnApproved</option>
            <option value="2">Archived</option>
          </select>
        </div>
      </div>

      {/* Projects Table */}
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Project ID</th>
              <th>Project Title</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Actions</th>
              
            </tr>
          </thead>
          <tbody>
            {projects.length > 0 ? (
              projects.map((project) => (
                <tr key={project.projId}>
                  <td>{project.projId}</td>
                  <td>{project.projTitle}</td>
                  <td>{project.projStartDate}</td>
                  <td>{project.projEndDate}</td>
                  <td>
                  <span className={`badge ${project.status === 0 ? 'bg-danger' : project.status === 1 ? 'bg-success' : project.status === 2 ? 'bg-warning' : 'bg-info'}`}>{
                      project.status === 0 ? 'UnApproved' :
                      project.status === 1 ? 'Approved Level 1' :
                      project.status === 2 ? 'Archived' :
                      'Approved Level 2'
                    }</span>
                  </td>
                  <td>
                                <button 
                                        className="btn btn-primary" 
                                        onClick={() => navigate.push(`/viewProjdean/${project.projId}`)}
                                    >
                                        View Details
                                    </button>
                                </td>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No projects found for the selected status.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectStatusHOD;
